'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import Big from 'UIComponents/elements/Big';
const StyledScrollToResultsDiv = styled.div.attrs(props => {
  const {
    opacity,
    fixed
  } = props;
  return {
    style: {
      opacity,
      visibility: opacity <= 0 ? 'hidden' : 'visible',
      position: fixed ? 'fixed' : 'absolute',
      top: fixed ? '50%' : 'inherit',
      bottom: fixed ? 'inherit' : `${window.innerHeight / 2}px`
    }
  };
}).withConfig({
  displayName: "ScrollToResults__StyledScrollToResultsDiv",
  componentId: "sc-7b7q1b-0"
})(["width:300px;margin-top:-50px;margin-left:", "px;text-align:center;"], props => props.containerWidth / 2 - 150);

const ScrollToResults = ({
  containerWidth,
  opacity,
  fixed
}) => {
  return /*#__PURE__*/_jsxs(StyledScrollToResultsDiv, {
    containerWidth: containerWidth,
    opacity: opacity,
    fixed: fixed,
    children: [/*#__PURE__*/_jsx(UIButton, {
      use: "link",
      onClick: () => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      }),
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "next",
        size: "xs",
        style: {
          transform: 'rotate(-90deg)'
        }
      })
    }), /*#__PURE__*/_jsx(Big, {
      className: "display-block",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "ecosystemMarketplaceCore.storefront.scrollToTop_jsx",
        elements: {
          Link: UIButton
        },
        options: {
          use: 'link',
          onClick: () => window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
        }
      })
    })]
  });
};

ScrollToResults.propTypes = {
  containerWidth: PropTypes.number.isRequired,
  fixed: PropTypes.bool,
  opacity: PropTypes.number.isRequired
};
export default ScrollToResults;